/** Trust line under the card fields: the card is handled by Stripe, never by our servers. */
export function StripeBadge() {
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 11.5,
        color: '#777',
        marginTop: 2,
      }}
    >
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" aria-hidden="true">
        <rect x="1" y="6" width="10" height="7.5" rx="1.5" fill="#777" />
        <path d="M3.5 6V4a2.5 2.5 0 0 1 5 0v2" stroke="#777" strokeWidth="1.5" fill="none" />
      </svg>
      <span>
        Secured by <b style={{ color: '#444', letterSpacing: '-.01em' }}>Stripe</b> · your card
        never touches our servers
      </span>
    </span>
  );
}
